import EnhancedTree from "../enhanced-tree";
import {getLocalizedStr} from "../../middlewares/i18n/utils";
import {getNodes, getNodesAtDepth} from "../../utils/tree";
import _ from "lodash";
import {getTreeFilterStrFromObj, TREE_FILTER_MAX_LENGTH, TREE_NODE_KEY_PREFIX} from "./utils";
import {getNormalizedColumnName} from "../../utils/normalizers";
import {FILTER_MODE_IN,  getArtefactTripletFromString} from "../../utils/sdmxJson";
import {Col, Divider, Modal, Radio, Row} from "antd";
import React from "react";
import {translate} from 'react-i18next';
import TreeFilterTimePeriod from "./TimePeriod";
import Call from "../../hocs/call";
import { compose } from "redux";
import { connect } from "react-redux";
import { cancelObjTimePeriodValues, deleteFilteredObjTimePeriodMode } from "../../scenes/data-manager/cube-list/actions";
import { addSpinnerAction, completeSpinnerAction } from "../../middlewares/spinner/actions";
import { showQueryFormSpinner } from "./actions";


const TREE_NODE_KEY_ALL = TREE_NODE_KEY_PREFIX + 'ALL';
const TREE_NODE_KEY_OF_LEVEL_PREFIX = TREE_NODE_KEY_PREFIX + 'OF_LEVEL_';

const mapStateToProps = state => ({
    deleteFilteredTimePeriodMode:state.scenes.dataManager.cubeList.deleteFilteredTimePeriodMode
})


const mapDispatchToProps = dispatch => ({
    onTimePeriodDeleteMode: (mode) => dispatch(deleteFilteredObjTimePeriodMode(mode)),
    onCancelValuesObj: (colName) =>dispatch(cancelObjTimePeriodValues(colName)),
    showSpinner: uuid => dispatch(addSpinnerAction(showQueryFormSpinner(), uuid)),
    hideSpinner: uuid => dispatch(completeSpinnerAction(showQueryFormSpinner(), uuid))
})

const TimePeriodTree = ({
                          t,
                          column,
                          dataLanguage,
                          appLanguage,
                          dataLanguages,
                          treeFilter,
                          freqCol,
                          isCC,
                          columns,
                          callOnColumnValuesChangeWithSpinner,
                          index,
                          disabled,
                          tempTPTo,
                          tempTPFrom,
                          setTPFromTo,
                          currentTab,
                          fetchColumnCodelistCount,
                          fetchColumnCodelistTree,
                          fetchColumnFilteredValues,
                          indexColumn,
                          itemsOrderAnnotationType,
                          isDdbDataflow,
                          isSdmx,
                          onTimePeriodDeleteMode,
                          deleteFilteredTimePeriodMode,
                          onCancelValuesObj,
                          showSpinner,
                          hideSpinner
                        }) => {

  const levelNodesKeys =
    [...Array(column.filteredCodelistTreeMaxDepth)]
      .map((_, index) => TREE_NODE_KEY_OF_LEVEL_PREFIX + index);

  const callCancelObjToChangeMode = () => {
      showSpinner();
      window.setTimeout(() => {
          hideSpinner();
          onCancelValuesObj(column.ColName) // delete filtermap the column
      }, 0);
      if(deleteFilteredTimePeriodMode === 'RANGE'){
      setTPFromTo({
          tempTPFrom: null,
          tempTPTo: null
          });
      }
  }

const callChangeModeTimePeriod = (mode) => {
    showSpinner();
    window.setTimeout(() => {
        hideSpinner();
        onTimePeriodDeleteMode(mode) 
      }, 0);
}


  return (
    <React.Fragment>
        <Row type="flex" align="middle">
            <Col>
            <Radio.Group value={deleteFilteredTimePeriodMode}
                onChange={({target}) => {
                    deleteFilteredTimePeriodMode !== target.value && 
                    _.some(treeFilter[column.ColName]) ?
                        Modal.confirm({
                            title: t('components.treeFilter.confirms.deleteFilterChange.title'),
                            content: t('components.treeFilter.confirms.deleteFilterChange.content'),
                            onOk() {
                            callCancelObjToChangeMode() 
                            callChangeModeTimePeriod(target.value) 
                            },
                            cancelText: t('commons.buttons.cancel.title')
                            }) :
                        callChangeModeTimePeriod(target.value) 
                    }
                    }
                    >
                    <Radio.Button value={'RANGE'}>{t('components.treeFilter.filterModeRadio.range.title')}</Radio.Button>
                    <Radio.Button value={'IN'}>{t('components.treeFilter.filterModeRadio.in.title')}</Radio.Button>
            </Radio.Group> 
            </Col>      
        </Row>  
        <Divider />
        {deleteFilteredTimePeriodMode === 'RANGE' && 
            <Call
            cb={fetchColumnCodelistCount}
            cbParam={{
              codelistTriplet: freqCol
                ? (freqCol.CodelistCode === null || getArtefactTripletFromString(freqCol.CodelistCode))
                : null,
              language: dataLanguage || appLanguage
            }}
            disabled={!freqCol || freqCol.CodelistCode === null || freqCol.codelistCount !== null}
          >
            <Call
              cb={fetchColumnCodelistTree}
              cbParam={{
                codelistTriplet: freqCol
                  ? (freqCol.CodelistCode === null || getArtefactTripletFromString(freqCol.CodelistCode))
                  : null,
                language: dataLanguage || appLanguage,
                itemsOrderAnnotationType,
                isDdbDataflow
              }}
              disabled={
                !freqCol || !isCC || !fetchColumnFilteredValues ||
                freqCol.CodelistCode === null || freqCol.codelistCount === null ||
                freqCol.codelistTree !== null}
            >
              <Call
                cb={fetchColumnFilteredValues}
                cbParam={{
                  colNames: [freqCol ? freqCol.name : null],
                  filterStr: ""
                }}
                disabled={
                  !freqCol || !isCC || !fetchColumnFilteredValues ||
                  (freqCol.CodelistCode !== null && (freqCol.codelistTree === null || freqCol.filteredCodelistTree !== null)) ||
                  (!isCC && freqCol.CodelistCode === null && freqCol.filteredValues === null) ||
                  currentTab !== String(indexColumn)
                }
              >
                <TreeFilterTimePeriod
                  disabled={disabled}
                  treeFilter={treeFilter}
                  columns={columns}
                  column={column}
                  index={indexColumn}
                  isCC={isCC}
                  isSdmx={isSdmx}
                  tempTPFrom={tempTPFrom}
                  tempTPTo={tempTPTo}
                  setTPFromTo={setTPFromTo}
                  callOnColumnValuesChangeWithSpinner={callOnColumnValuesChangeWithSpinner}
                  usePickers={!fetchColumnFilteredValues}
                />
              </Call>
            </Call>
          </Call>
        }
        {deleteFilteredTimePeriodMode === 'IN' && 
             <EnhancedTree
            treePrefix={
                    column.filteredValues && (
                        (column.filteredCodelistTree && column.filteredCodelistTree.length > 0) ||
                        column.filteredValues.length > 0
                    )
                 ? [
                   (() => {
                     const obj = {
                       id: TREE_NODE_KEY_OF_LEVEL_PREFIX + 0,
                       name: {
                         en: t('components.treeFilter.levelNode', {level: 0})
                       },
                       level: 0,
                     };
                     if (column.filteredCodelistTreeMaxDepth !== null && column.filteredCodelistTreeMaxDepth !== 0) {
                       [...Array(column.filteredCodelistTreeMaxDepth - 1)]
                         .forEach(() => {
                           let pointer = obj;
                           let counter = 0;
                           while (pointer.codes) {
                             pointer = pointer.codes[0];
                             counter++;
                           }
                           pointer.codes = [
                             {
                               id: TREE_NODE_KEY_OF_LEVEL_PREFIX + Number(counter + 1),
                               name: {
                                 en: t('components.treeFilter.levelNode', {level: counter + 1})
                               },
                               level: counter + 1
                             }
                           ]
                         });
                     }
                     return obj;
                   })()
                 ]
                 : null
             }
            tree={
               column.filteredValues
                 ? (
                   column.filteredCodelistTree ||
                   column.filteredValues
                     .filter(val => val !== null)
                     .map(val => ({
                       id: val,
                       name: val
                     }))
                 )
                 : null
             }
             getNodeKey={({id}) => id}
             childrenKey="codes"
             idKey="id"
             nameKey="name"
             catIdKey="id"
             catNameKey="name"
             icon="file-text"
             hiddenIdKeys={[
               TREE_NODE_KEY_ALL,
               ...levelNodesKeys
             ]}
             isRootIconLikeChildrenIcon
             isEmptyCategoryIconLikeLeafIcon
             placeholder={
               (
                 (
                   column.filteredCodelistTree && column.filteredValues &&
                   column.filteredCodelistTree.length === 0
                 ) ||
                 (column.filteredValues && column.filteredValues.length === 0)
               )
                 ? t("components.treeFilter.noValuesPlaceholder")
                 : ((
                     column.filteredCodelistTree === null && column.filteredValues &&
                     column.filteredValues.filter(val => val !== null).length === 0
                   )
                   ? t("components.treeFilter.noValuesInColumnPlaceholder")
                   : null
                 )
             }
             getFilter={
               searchText =>
                 ({id, name}) => {
                   const search = searchText.toLowerCase();
                   return (id && id.toLowerCase()
                       .indexOf(search) >= 0) ||
                     getLocalizedStr(name, dataLanguage || appLanguage, dataLanguages)
                       .toLowerCase()
                       .indexOf(search) >= 0;
                 }
             }
             checkable
             checkStrictly
             onCheck={({checked}, {node, checked: isChecked}) => {
       
               const callOnColumnValuesChange = () => {
                 let newChecked = [];
       
                 if (node.props.eventKey === TREE_NODE_KEY_ALL) {
                   if (isChecked) {
                     newChecked = [
                       TREE_NODE_KEY_ALL,
                       ...levelNodesKeys,
                       ...getNodes(column.filteredCodelistTree, "codes", () => true)
                         .map(({id}) => id)
                     ];
                   } else {
                     newChecked = [];
                   }
                 } else if (levelNodesKeys.includes(node.props.eventKey)) {
                   const level = Number(node.props.eventKey.replace(TREE_NODE_KEY_OF_LEVEL_PREFIX, ""));
       
                   const keysAtDepth = getNodesAtDepth(
                     column.CodelistCode
                       ? column.filteredCodelistTree
                       : (column.filteredValues || []).map(val => ({
                         id: val,
                         name: val
                       })),
                     "codes",
                     level + 1)
                     .map(({id}) => id);
       
                   if (isChecked) {
                     newChecked = _.uniq([
                       TREE_NODE_KEY_OF_LEVEL_PREFIX + level,
                       ...checked,
                       ...keysAtDepth
                     ]);
                   } else {
                     newChecked = checked.filter(key => !keysAtDepth.includes(key));
                   }
                 } else {
                   newChecked = checked.filter(key => !key.startsWith(TREE_NODE_KEY_PREFIX));
                 }
       
                 const newTreeFilter = _.cloneDeep(treeFilter);
       
                 const columnName = !isCC ? column.name : getNormalizedColumnName(column.name);
       
                 newChecked = newChecked.filter(id => id.startsWith(TREE_NODE_KEY_PREFIX) || (column.filteredValues || []).includes(id));
       
                 newTreeFilter[columnName] = {
                   mode: newTreeFilter[columnName] && newTreeFilter[columnName].mode
                     ? newTreeFilter[columnName].mode
                     : FILTER_MODE_IN,
                   values: newChecked
                 };
       
                 const colNames = columns.map(({name}) =>
                   !isCC ? name : getNormalizedColumnName(name));
                 const colIndex = colNames.indexOf(columnName);
                 const subsequentColNames = colNames.splice(colIndex + 1);
       
                 // delete filters for subsequent cols
                 subsequentColNames.forEach(name => {
                   delete newTreeFilter[!isCC ? name : getNormalizedColumnName(name)];
                 });
                 if (
                   subsequentColNames.includes(column.name !== "ID_TIME_PERIOD") ||
                   subsequentColNames.includes(column.name !== "TIME_PERIOD")
                 ) {
                   setTPFromTo({
                     tempTPFrom: null,
                     tempTPTo: null
                   });
                 }
       
                 if (!isCC && getTreeFilterStrFromObj(newTreeFilter, colNames).length > TREE_FILTER_MAX_LENGTH) {
                   Modal.error({
                     title: t('components.treeFilter.errors.maxLength.title'),
                     content: t('components.treeFilter.errors.maxLength.content')
                   });
                 } else {
                   callOnColumnValuesChangeWithSpinner(column.name, newChecked);
                 }
               };
       
               const subsequentColumnNames = columns.slice(indexColumn + 1).map(({name}) =>
                 !isCC ? name : getNormalizedColumnName(name));
               if (subsequentColumnNames.find(name => treeFilter[name])) {
              
                 Modal.confirm({
                   title:t('components.treeFilter.confirms.filterChange.title'),
                   content: t('components.treeFilter.confirms.filterChange.content'),
                   onOk() {
                     callOnColumnValuesChange();
                   },
                   cancelText: t('commons.buttons.cancel.title')
                 })
               } else {
                 callOnColumnValuesChange();
               }
             }}
             checkedKeys={{
               checked: treeFilter[column.name]
                 ? treeFilter[column.name].values
                 : treeFilter[getNormalizedColumnName(column.name)]
                   ? treeFilter[getNormalizedColumnName(column.name)].values
                   : []
             }}
             getNodeIsCheckable={
               ({id}) => !disabled && (id.startsWith(TREE_NODE_KEY_PREFIX) || (column.filteredValues || []).includes(id))
             }
             getNodeIsCounted={
               ({id}) => !disabled && (id.startsWith(TREE_NODE_KEY_PREFIX) || (column.filteredValues || []).includes(id))
             }
             disabledCheckboxTitle={
               disabled
                 ? null
                 : () => t('components.treeFilter.disabledCheckbox.title')
             }
           />
        }
    </React.Fragment>
  );
};

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
    )(TimePeriodTree);